export const vehicleClassLabels: Readonly<Record<string, string>> = {
  car: "Pkw",
  pkw: "Pkw",
  truck: "Lkw",
  lkw: "Lkw",
  bus: "Bus",
  van: "Transporter",
  transporter: "Transporter",
  vehicle: "Fahrzeug",
  twowheeler: "Zweirad",
  rad: "Zweirad",
  person: "Person",
  fuss: "Person",
  unknown: "Unbekannt",
  miv: "MIV",
  mv: "MV",
};

export const vehicleClassColors: Readonly<Record<string, string>> = {
  car: "#0072b2",
  pkw: "#0072b2",
  truck: "#d55e00",
  lkw: "#d55e00",
  bus: "#009e73",
  van: "#e69f00",
  transporter: "#e69f00",
  vehicle: "#6f4eaa",
  twowheeler: "#9b8700",
  rad: "#9b8700",
  person: "#cc79a7",
  fuss: "#cc79a7",
  unknown: "#5f6368",
  miv: "#2e6684",
  mv: "#4f6571",
};

export function vehicleClassLabel(value: unknown) {
  const vehicleClass = String(value);
  return vehicleClassLabels[vehicleClass] ?? vehicleClass;
}

export function isVehicleClass(value: unknown) {
  return Object.hasOwn(vehicleClassColors, String(value));
}

export function vehicleClassColor(value: unknown) {
  return vehicleClassColors[String(value)] ?? vehicleClassColors.unknown;
}
